import React, { useState } from "react";
import enquiry1 from "../../assets/img/about/15.png";

const questions = [
  {
    id: 1,
    question: "What services do you offer?",
    answer:
      "We offer a wide range of IT services, including web development, mobile app development, SEO, digital marketing, and IT support. Our expert team delivers tailored solutions to enhance your online presence, streamline operations, and drive business growth",
  },
  {
    id: 2,
    question: "How experienced is your team?",
    answer:
      "Our team brings over 10 years of experience in all aspects of IT, including web development, mobile apps, SEO, digital marketing, and IT support, ensuring top-quality solutions for your business",
  },
  {
    id: 3,
    question: "Can you provide examples of past projects?",
    answer:
      "We’ve completed diverse projects, including custom mobile apps, responsive websites, and effective digital marketing campaigns. We can provide detailed case studies or client testimonials showcasing our expertise and successful results",
  },
];

function Enquiry() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-area pd-bottom-120">
      <div className="container">
        <div className="row pd-top-120">
          <div className="col-xl-7 col-lg-6 col-md-8 order-lg-last">
            <div className="about-thumb-inner video-thumb">
              <img className="main-img" src={enquiry1} alt="img" />
            </div>
          </div>
          <div className="col-xl-5 col-lg-6 align-self-center">
            <div className="section-title mb-0 mt-4 mt-lg-0">
              <h6 className="sub-title">YOUR ANSWER</h6>
              <h2 className="title">
                Have Any <span>Question</span> Please?
              </h2>
            </div>
            <div
              className="accordion accordion-inner style-2 accordion-icon-left mt-3"
              id="accordionExample"
            >
              {questions.map((item, index) => (
                <div className="accordion-item" key={item.id}>
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className={`accordion-button ${
                        openIndex === index ? "" : "collapsed"
                      }`}
                      type="button"
                      onClick={() => toggleAccordion(index)}
                      aria-expanded={openIndex === index}
                      aria-controls={`collapse${item.id}`}
                    >
                      {item.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className={`accordion-collapse collapse ${
                      openIndex === index ? "show" : ""
                    }`}
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#accordionExample"
                    style={{
                      transition: "max-height 0.3s ease",
                      overflow: "hidden",
                      maxHeight: openIndex === index ? "200px" : "0",
                    }}
                  >
                    <div className="accordion-body">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Enquiry;
